import * as React from "react";
import { Autocomplete, TextField } from "@mui/material";
import "./style.scss";

const CustomSelect = ({
  options,
  name,
  label,
  renderOption,
  getOptionLabel,
  onChange,
  value,
}) => {
  // Replace this with your app logic for determining dark modes
  const filterOptions = (options, { inputValue }) => {
    const normalizedInput = inputValue.toLowerCase();
    return options.filter(
      (option) =>
        option.description?.toLowerCase().includes(normalizedInput) ||
        option.league?.toLowerCase().includes(normalizedInput) ||
        (option.site && option.site.toLowerCase().includes(normalizedInput))
    );
  };
  return (
    <Autocomplete
      value={value}
      options={options}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          variant="outlined"
          sx={{
            "& fieldset": {
              borderColor: "rgb(61 77 96)",
              "&:hover": {
                borderColor: "rgb(61 77 96)",
              },
            },
          }}
          className="w-full hover:cursor-pointer"
        />
      )}
      getOptionDisabled={(option) => !option.active}
      onChange={(e, value) =>
        onChange({
          target: {
            name,
            value: value?.id,
          },
        })
      }
      filterOptions={filterOptions}
      getOptionLabel={getOptionLabel || null}
      renderOption={renderOption || null}
      classes={{
        root: "text-white",
        input: "text-white",
      }}
      isOptionEqualToValue={(option, value) => option === value}
      className="w-full custom-select"
      // popupIcon={<span className="material-icons">arrow_drop_down</span>}
    />
  );
};

export default CustomSelect;
